// A game player's character, or null until the season's characters are in
// the cache (before then the cache hands back an empty placeholder).
export default function loadedCharacterOf(game, player) {
	if(!game || !player) {
		return null;
	}
	const character = game.players?.[player.id]?.getSelectedCharacterIfLoaded?.() || null;
	return character && character.name ? character : null;
}

// What a player's Random pick landed on, or null (not Random, not rolled yet,
// or not in the cache yet).
export function loadedRolledCharacterOf(game, player) {
	if(!game || !player) {
		return null;
	}
	const character = game.players?.[player.id]?.getRolledCharacterIfLoaded?.() || null;
	return character && character.name ? character : null;
}
